

import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import ProjectItem from './ProjectItem.vue';
import ProgressItem from './ProgressItem.vue';
import EmployeeItem from './EmployeeItem.vue';

import CircleProgressItem from './CircleProgressItem.vue';
import TimeLineItem from './TimeLineItem.vue';
import ActivityItem from './ActivityItem.vue';
import AddActivityItem from './AddActivityItem.vue';
import SchedulerItemRow from '../scheduler-graph/SchedulerItemRow.vue';
import moment from 'moment';
import initialsHelper from '@/helpers/cardInfoHelperFunctions/initialsHelper';
import { hslColorFromName } from "@/utils/hslColorFromName";

@Component({
    components: {
        CircleProgressItem,
        ProjectItem,
        TimeLineItem,
        ProgressItem,
        ActivityItem,
        AddActivityItem,
        SchedulerItemRow,
        EmployeeItem
    },
})
export default class ContractorCollapse extends Vue {
    @Prop({ type: Array, default: null }) readonly weekDates!: any[];
    @Prop({ type: Array, default: null }) readonly quarterMonths!: any[];
    @Prop({ type: Array, default: null }) readonly weeks!: any[];
    @Prop({ type: Boolean, default: null }) readonly isDays!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isMonths!: boolean;
    @Prop({ type: Boolean, default: null }) readonly isWeeks!: boolean;
    @Prop({ type: String, default: null }) readonly columnSpan!: string;
    @Prop({ type: Object, default: null }) readonly contractor!: any;
    @Prop({ type: String, default: null }) readonly filterBy!: string;
    @Prop({ type: Date, default: null }) readonly getEarliestDate!: Date;
    @Prop({ type: Date, default: null }) readonly pickerCurrentDate!: Date;
    @Prop({ type: Boolean, default: false }) readonly isCollapsed!: boolean;
    @Prop({ type: String, default: null }) readonly companyId!: string;
    @Prop({ type: Object, default: null }) readonly currentUser!: any;
    @Prop({ type: Number, default: 0 }) readonly index!: any;


    isOpened: boolean = false;
    currentDate = new Date();


    toggleCollapse(value: boolean) {
        this.isOpened = value;
    }

    getRandomewidth(min: number, max: number) {
        return Math.floor(Math.random() * (max - min + 1)) + min;
    }

    get completedProjects() {
        //count completed projects in a contractor
        return this.contractor.projects.filter((project: any) => project.completed === project.activities.length).length;
    }
    get projectsInprogress() {
        //count completed projects in a contractor
        return this.contractor.projects.filter((project: any) => !project.completed).length;
    }

    //get completed activities in a project
    getCompletedProjectActivitiesActivities(project: any) {
        return project.activities.length <= 0 ? 0 : project.activities.filter((activity: any) => activity.completed === true).length;
    }

    get color(): string {
        return hslColorFromName(this.initial);
    }

    get initial(): string {
        return initialsHelper(this.contractor?.name);
    }

    //get activity percentage complete
    getActivityPercentageComplete(activity: any) {
        if (this.checkDateHaveParsed(activity.start_date)) {
            let totalHours = this.getHoursBetweenDates(activity.start_date, activity.end_date);
            let hoursCurrentdate = this.getHoursBetweenDates(activity.start_date, this.currentDate);
            if (hoursCurrentdate <= 0) {
                return 0;
            }
            return hoursCurrentdate > 100 ? 100 : Math.floor((hoursCurrentdate / totalHours) * 100) > 100 ? 100 : Math.floor((hoursCurrentdate / totalHours) * 100);
        }
        return 0;
    }

    getActivityCompletedSteps(activity: any) {
        return Math.floor(this.getActivityPercentageComplete(activity) / 10);
    }
    //get total hours of a contractor with moment js
    get managerTotalHours() {
        return this.getHoursBetweenDates(this.earliestStartDate, this.earliestEndDate);
    }
    get getLeftForTimeLineMargin() {
        let hours = this.getHoursBetweenDates(this.getEarliestDate, this.currentDate);
        return 350 + this.getProportion(hours);
    }

    get contractorProgressWidth() {
        let propotionValue = this.getProportion(this.managerTotalHours)
        return propotionValue;
    }

    //get project progress width
    getProjectProgressItemWidth(project: any) {
        let totalHours = this.getHoursBetweenDates(project.start_date, project.end_date);
        let propotionValue = this.getProportion(totalHours)
        return propotionValue;
    }
    getActivityProgressitemWith(activity: any) {
        let totalHours = this.getHoursBetweenDates(activity.start_date, activity.end_date);
        let propotionValue = this.getProportion(totalHours)
        return propotionValue;
    }

    //get earliest start date of a contractor
    get earliestStartDate() {
        let earliestDate = this.contractor?.projects[0]?.start_date;
        this.contractor.projects.forEach((project: any) => {
            if (project.start_date < earliestDate) {
                earliestDate = project.start_date;
            }
        })
        return earliestDate;
    }

    //get latest end date of a contractor
    get earliestEndDate() {
        let latestDate = this.contractor?.projects[0]?.end_date;
        this.contractor.projects.forEach((project: any) => {
            if (project.end_date > latestDate) {
                latestDate = project.end_date;
            }
        })
        return latestDate;
    }

    get getLeftMargin() {
        let hours = this.getHoursBetweenDates(this.getEarliestDate, this.earliestStartDate);
        return this.getProportion(hours);
    }
    getProjectLeftMargin(project: any) {
        let hours = this.getHoursBetweenDates(this.getEarliestDate, project.start_date);
        return this.getProportion(hours);
    }
    getActivityLeftMargin(activity: any) {
        let hours = this.getHoursBetweenDates(this.getEarliestDate, activity.start_date);
        return this.getProportion(hours);
    }
    checkDateHaveParsed(date: any) {
        let current = moment(this.currentDate);
        let checkDate = moment(date);
        var dDiff = current.diff(checkDate);
        return dDiff > 0 ? true : false;
    }

    get getContractorProgressWidth() {
        if (this.checkDateHaveParsed(this.earliestStartDate)) {
            if (this.checkDateHaveParsed(this.earliestEndDate)) {
                return 100;
            }
            let totalHours = this.getHoursBetweenDates(this.earliestStartDate, this.currentDate);
            return this.getProportion(totalHours) / this.contractorProgressWidth * 100;
        }
        return 0;

    }
    getProjectProgressWidth(project: any) {
        if (project.completed) {
            return 100;
        }
        if (this.checkDateHaveParsed(project.start_date)) {
            if (this.checkDateHaveParsed(project.end_date)) {
                return 100;
            }
            let totalHours = this.getHoursBetweenDates(project.start_date, this.currentDate);
            return this.getProportion(totalHours) / this.getProjectProgressItemWidth(project) * 100;
        }
        return 0;
    }
    getActivityProgressWidth(activity: any) {
        if (activity.completed) {
            return 100;
        }
        if (this.checkDateHaveParsed(activity.start_date)) {
            if (this.checkDateHaveParsed(activity.end_date)) {
                return 100
            }
            let totalHours = this.getHoursBetweenDates(activity.start_date, this.currentDate);
            return this.getProportion(totalHours) / this.getActivityProgressitemWith(activity) * 100;
        }
        return 0;
    }

    get propotionValue() {
        if (this.isDays) {
            return 119;
        } else if (this.isWeeks) {
            return 119;
        } else if (this.isMonths) {
            return 119;
        }
    }
    //create function to return proportion
    getProportion(hours: number) {
        if (this.isDays) {
            return (hours / 24) * (window.innerWidth * (119.14272 / 1366))
        }
        else if (this.isWeeks) {
            return (hours / 168) * (window.innerWidth * (208.5 / 1366))
        }
        else if (this.isMonths) {
            return (hours / 720) * (window.innerWidth * (278 / 1366))
        }
    }

    get markerHidden(): string {
        if(this.getLeftForTimeLineMargin < 350 || this.getLeftForTimeLineMargin > window.innerWidth) {
            return "hidden";
        }
        return "";
    }

    //create function to calc hours between two dates with moment js
    getHoursBetweenDates(startDate: Date, endDate: Date) {
        let start = moment(startDate);
        let end = moment(endDate);
        let duration = moment.duration(end.diff(start));
        let hours = duration.asHours();
        return hours;
    }
    //get project total hours
    getProjectTotalHours(project: any) {
        let totalHours = 0;
        project.activities.forEach((activity: any) => {
            totalHours += activity.confirmed_hours;
        })
        return totalHours;
    }


    //get earliest start date of a project
    getProjectEarliestStartDate(project: any) {
        let earliestDate = project?.activities[0]?.start_date;
        project.activities.forEach((activity: any) => {
            if (activity.start_date < earliestDate) {
                earliestDate = activity.start_date;
            }
        })
        return earliestDate;
    }

    @Watch('isCollapsed')
    onCollapseChange() {
        this.isOpened = this.isCollapsed;
    }
}
